export const navItems = [
  {
    name: 'GDPR Compliance',
    link: '/gdpr',
    dataTestId: 'gdpr'
  },
  {
    name: 'Privacy Policy',
    link: '/privacy-policy',
    dataTestId: 'privacy-policy'
  },
  {
    name: 'Privacy Statement',
    link: '/privacy-statement',
    dataTestId: 'privacy-statement'
  },
  {
    name: 'Refund Policy',
    link: '/refund-policy',
    dataTestId: 'refund-policy'
  },
  {
    name: 'Terms of Service',
    link: '/terms-of-service',
    dataTestId: 'terms-of-service'
  }
];
